module.exports = __webpack_public_path__ + "static/img/BodyFeel02.459c246.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/Buy/BodyFeel/BodyFeel02.png
// module id = ULxh
// module chunks = 12